<template>
  <div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <!-- 주문상품 -->
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="주문상품">
            <div class="columns is-multiline">
              <div class="column is-full" v-if="value.order_product.length>0">
                <table class="table">
                  <thead>
                  <tr>
                    <td>이미지</td>
                    <td>상품명</td>
                    <td>수량</td>
                    <td>상품금액</td>
                    <td>할인금액</td>
                    <td>배송비</td>
                    <td>주문금액</td>
                    <td>삭제</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(op,idx) in value.order_product" :key="'order_prod-'+idx">
                    <td><div style="text-align: center; display: inline-block;"
                             :style="imgField(op.img)"></div></td>
                    <td style="text-align:left !important">
                      <div>{{ op.name }}</div>
                      <div class="flex"
                           v-for="(option, option_idx) in op.order_product_option"
                           :key="'option-'+option_idx">
                        <span v-if="optionType(op.selectorStocks, option.option_id)===0">[기본옵션]</span>
                        <span v-if="optionType(op.selectorStocks, option.option_id)===1">[추가옵션]</span>
                        {{ optionName(op.selectorStocks, option.option_id) }} X {{ option.quantity }}
                      </div>
                    </td>
                    <!--<td><input class="input product-short-input"
                               :value="op.quantity"
                               @input="e=>setNumber(e, op, 'quantity', 3)"
                               type="number"></td>-->
                    <td>{{ op.op_quantity }}</td>
                    <td>{{ op.op_product_price | currency }}</td>
                    <td>{{ op.op_discount_price | currency }}</td>
                    <td v-if="op.rowspan>0" :rowspan="op.rowspan">
                      {{ op.op_delivery_price | currency }}
                    </td>
                    <td>
                      <span class="size-16" style="margin-bottom: 24px;">{{ op.op_order_price | currency }}</span>
                    </td>
                    <td><button class="button half is-danger" @click="deleteOrderProduct(idx)">삭제</button></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="column is-full">
                <div class="flex btn-group-justify-end">
                  <button class="button" @click="clickProduct">상품추가</button>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <!-- 주문자 정보 -->
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="주문자 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="회원구분">
                  <div class="flex">
                    <lp-radio :val.sync="is_user"
                              value_name="value"
                              label_name="label"
                              :data="is_user_arr"></lp-radio>
                    <button class="button" v-if="is_user" @click="$modal.show('userlistModal')">회원선택</button>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="주문자성함*">
                  <input class="input"
                         :value="value.order.name"
                         @input="e=>value.order.name=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="전화번호">
                  <input class="input"
                         :value="value.order.tphone"
                         @input="e=>value.order.tphone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="휴대전화번호*">
                  <input class="input"
                         :value="value.order.phone"
                         @input="e=>value.order.phone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="이메일*">
                  <input class="input"
                         :value="value.order.email"
                         @input="e=>value.order.email=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="주소*">
                  <lp-address :data.sync="value.order.address"></lp-address>
                </admin-form-item>
              </div>-->
            </div>
          </admin-box-item>
        </div>
      </div>

      <!-- 받는 분 정보 -->
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="수령자 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <lp-check-bool :checkedVal.sync="isEqualUser"
                               label="주문자 정보와 상품 정보가 동일합니다."></lp-check-bool>
              </div>
              <div class="column is-full">
                <admin-form-item label="수령인*">
                  <input class="input"
                         :value="value.delivery.name"
                         @input="e=>value.delivery.name=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="전화번호">
                  <input class="input"인
                         :value="value.delivery.tphone"
                         @input="e=>value.delivery.tphone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="휴대전화번호*">
                  <input class="input"
                         :value="value.delivery.phone"
                         @input="e=>value.delivery.phone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배송지 주소*">
                  <lp-address :data.sync="value.delivery.address"></lp-address>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배송 메모">
                  <input class="input"
                         :value="value.delivery.memo"
                         @input="e=>value.delivery.memo=e.target.value"
                         type="text" maxlength="100">
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <!-- 결제정보 -->
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="결제정보">
            <div class="columns is-multiline">
              <!--<div class="column is-full">
                <admin-form-item label="수수료 합계 금액">
                  {{ value.order.comm_price | currency }}
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="포인트 합계 금액">
                  {{ value.order.point | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="할인 합계 금액">
                  {{ value.order.discount_price | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상품 합계 금액">
                  {{ value.order.product_price | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배송비">
                  {{ value.order.delivery_cost | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="최종 결제 금액">
                  {{ value.order.total_price | currency }}
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <!-- 결제수단 -->
      <!--<div class="column is-full">-->
        <!--<div class="box">-->
          <!--<admin-box-item title="환불 받을 계좌">-->
            <!--<div class="columns is-multiline">-->
              <!--<div class="column is-2">-->
                <!--<admin-form-item label="은행*">-->
                  <!--<input class="input"-->
                         <!--:value="value.order.refund_info.bank"-->
                         <!--@input="e=> value.order.refund_info.bank = e.target.value">-->
                <!--</admin-form-item>-->
              <!--</div>-->
              <!--<div class="column is-2">-->
                <!--<admin-form-item label="이름*">-->
                  <!--<input class="input"-->
                         <!--:value="value.order.refund_info.name"-->
                         <!--@input="e=> value.order.refund_info.name = e.target.value">-->
                <!--</admin-form-item>-->
              <!--</div>-->
              <!--<div class="column is-2">-->
                <!--<admin-form-item label="계좌번호*">-->
                  <!--<input class="input"-->
                         <!--:value="value.order.refund_info.account"-->
                         <!--@input="e=> value.order.refund_info.account = e.target.value">-->
                <!--</admin-form-item>-->
              <!--</div>-->
              <!--&lt;!&ndash;<div class="column is-full">-->
                <!--<admin-form-item label="입금계좌*">-->
                  <!--<span class="select">-->
                    <!--<select v-model="purchase.bank" @change="selectBank">-->
                      <!--<option v-for="bank in banklist">{{ bank.label }}</option>-->
                    <!--</select>-->
                  <!--</span>-->
                <!--</admin-form-item>-->
              <!--</div>&ndash;&gt;-->
            <!--</div>-->
          <!--</admin-box-item>-->
        <!--</div>-->
      <!--</div>-->

      <!-- 상품 목록 팝업 -->
      <modal name="productlistModal"
             :adaptive="true"
             :width="900"
             height="auto"
             class="modal-style">
        <lp-order-product-create
          @addProduct="addProduct"
          @closeModal="$modal.hide('productlistModal')"></lp-order-product-create>
      </modal>

      <!-- 회원 목록 팝업 -->
      <modal name="userlistModal"
             :adaptive="true"
             :width="900"
             height="auto"
             class="modal-style">
        <user-list page="purchase" @selectUser="selectUser"></user-list>

      </modal>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpAddress from "../../../module/common/LpAddress";
  import LpRadio from "../../../module/common/LpRadio";
  import UserList from "../../user/UserList";
  import Const from "../../../../utils/const"
  import LpOrderProductCreate from "../../../module/custom/LpOrderProductCreate";
  import OrderCreateMixin from "@/mixins/OrderCreateMixin"

  export default {
    name: 'order-create',
    components: {
      LpOrderProductCreate,
      UserList,
      LpRadio,
      LpAddress,
      LpCheckBool},
    mixins: [
      OrderCreateMixin
    ],
    data() {
      return {
        value: {
          // 주문
          order: {
            user_id: '',
            name: '',
            tphone: '',
            phone: '',
            email: '',
            refund_info: {
              name: '',
              account: '',
              bank: ''
            },
            total_price: 0,
            discount_price: 0,
            delivery_price: 0,
            pay_type: 2,  // 무통장 입금
            deposit_name: '',
            bank: '',
            point: 0
          },
          // 주문 상품
          order_product: [],
          // 배송지
          delivery: {
            name: '',
            tphone: '',
            phone: '',
            address:{
              sido: '',
              sigungu: '',
              dong: '',
              detail: '',
              post_code: '',
              old: '',
              new: ''
            },
            memo: ''
          },
        },
        // 주문자 정보와 동일
        isEqualUser: false,
        is_user: false,
        is_user_arr: [
          { label: '비회원', value: false },
          { label: '회원', value: true }
        ],
        // 은행 계좌 목록
        banklist: [],
        products: []
      }
    },
    watch: {
      isEqualUser(n){
        if(n) this.equalUser();
        else this.initDelivery();
      },
      'value.order.phone'(n) {
        this.value.order.phone = autoHyphenPhone(n);
      }
    },
    created() {},

    methods: {
      orderPrice(op, idx) {
        // return (this.calcProductPrice(op) - this.calcDiscountPrice(op) + this.calcDeliveryPrice(op, idx));
        return (this.calcProductPrice(op) - this.calcDiscountPrice(op));
      },
      clickProduct(){
        this.$modal.show('productlistModal');
      },
      // 수기주문 등록
      saveData(){
        let result = this.validCheck();
        if(result===false) return;
        for(let i=0; i<this.value.order_product.length; i++) {
          let op = this.value.order_product[i];
          op.quantity = op.op_quantity;
          op.total_price = op.op_order_price;
          op.discount_price = op.op_discount_price;
          op.product_price = op.op_product_price;
          op.delivery_cost = op.op_delivery_price;
        }
        this.$axios.post(this.getUrl('delivery/order'),{
          order: this.value.order,
          order_product: this.value.order_product,
          delivery: this.value.delivery
        }).then(res=>{
          if(res.status === 200) {
            this.toast('주문이 등록되었습니다.');
            this.$router.replace(this.getPath('delivery/order_list_order'));
          }
        })
      },
      // 주문자와 동일
      equalUser(){
        this.value.delivery.name = this.value.order.name;
        this.value.delivery.phone = this.value.order.phone;
        // this.value.delivery.email = this.value.order.email;
        // this.value.delivery.address = this.value.order.address;
      },
      // 배송지 정보 초기화
      initDelivery(){
        this.value.delivery = {
          name: "",
          tphone: "",
          phone: "",
          address: {
            sido: "",
            sigungu: "",
            dong: "",
            detail: "",
            post_code: "",
            old: "",
            new: "",
            latitude: "",
            longitude: ""
          },
          memo: ""
        }
      },
      addProduct(value){
        let order_product = this.cloneItem(this.value.order_product.concat(value));
        order_product.forEach(item=> {
          item.selected=true;
        })
        this.value.order_product = order_product;
        this.initialize();
        this.$modal.hide('productlistModal');
      },
      // 유저 선택
      selectUser(value){
        this.value.order.user_id = value.id;
        this.value.order.name = value.name;
        this.value.order.tphone = value.phone;
        this.value.order.phone = value.phone;
        this.value.order.email = value.email;
        // let address = {
        //   sido: "",
        //   sigungu: "",
        //   dong: "",
        //   detail: "",
        //   post_code: "",
        //   old: "",
        //   new: "",
        //   latitude: "",
        //   longitude: ""
        // }
        // if(value.address) address = value.address
        // this.value.order.address = address;
        this.$modal.hide('userlistModal');
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      deleteOrderProduct(index){
        removeIndex(this.value.order_product,index);
        this.initialize();
      },
      // 필수입력값 체크
      validCheck(){
        let err = '';
        if(!this.value.order.name) err = '주문자명을 입력하세요.';
        else if(!this.value.order.phone) err = '주문자 휴대전화번호를 입력하세요.';
        // else if(!this.value.order.phone) err = '주문자 전화번호를 입력하세요.';
        else if(!this.value.order.email) err = '주문자 이메일을 입력하세요.';
        // else if(!this.value.order.address.detail) err = '주문자 상세 주소를 입력하세요.';
        else if(!this.value.delivery.name) err = '수령자명을 입력하세요.';
        else if(!this.value.delivery.phone) err = '수령자 휴대전화번호를 입력하세요.';
        // else if(!this.value.delivery.phone) err = '수령자 전화번호를 입력하세요.';
        else if(!this.value.delivery.address.sido) err = '수령자 주소를 입력하세요.';
        else if(!this.value.delivery.address.detail) err = '수령자 상세주소를 입력하세요.';
        // else if(!this.value.order.refund_info.name) err = '환불받을 시 이름을 입력하세요.';
        // else if(!this.value.order.refund_info.account) err = '환불받을 시 계좌를 입력하세요.';
        // else if(!this.value.order.refund_info.bank) err = '환불받을 시 은행을 입력하세요.';
        // else if(!this.value.order.bank) err = '입금계좌를 입력하세요.';

      else if(this.value.order_product.length===0) {
          err = '상품을 선택하세요.';
        }
        if(err) {
          this.toast(err);
          return false;
        }
        else return true;
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .product-short-input
    width 89px
</style>
